import { CREATE_CARD_APPLICATIONS, ERR_CARD_APPLICATIONS } from "./types";
import axios from "axios";

export default data => async dispatch => {
  try {
    const newItem = await axios.post(`/api/card_applications`, data);
    dispatch(addAsync(newItem.data));
  } catch (err) {
    dispatch(getErr(err));
  }
};
const addAsync = pool => ({
  type: CREATE_CARD_APPLICATIONS,
  payload: pool
});
const getErr = err => ({
  type: ERR_CARD_APPLICATIONS,
  payload: err
});
